import { render, staticRenderFns } from "./CapitalRecord.vue?vue&type=template&id=24dfd4e9&scoped=true"
import script from "./CapitalRecord.vue?vue&type=script&lang=js"
export * from "./CapitalRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dfd4e9",
  null
  
)

export default component.exports